/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from '../../../core/services/config.service';
import { TrainData } from '../../../core/model/train-data.model';

/**
 * @export
 * @class LmsTrainDetailsComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train-details',
  templateUrl: './lms-train-details.component.html',
  styleUrls: ['./lms-train-details.component.scss']
})
export class LmsTrainDetailsComponent implements OnInit, OnDestroy {

  @Input() trainData: TrainData;
  trainLabel: any;
  trainTypeValue: string;

  /**
   * Creates an instance of LmsTrainDetailsComponent.
   * @param {ConfigService} configService
   * @memberOf LmsTrainDetailsComponent
   */
  constructor(private configService: ConfigService) {
    this.trainLabel = this.configService.getConfigData().trainLabel;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTrainDetailsComponent
   */
  ngOnInit() {
    if (this.trainData && this.trainData.trainType) {
      if (this.trainData.trainType.trim().toUpperCase() === 'TI') {
        this.trainTypeValue = ' - Inbound Arrived ' + this.trainData.lastReportingCityState;
      } else if (this.trainData.trainType.trim().toUpperCase() === 'TO') {
        this.trainTypeValue = ' - Ordered ' + this.trainData.lastReportingCityState;
      } else if (this.trainData.trainType.trim().toUpperCase() === 'TD') {
        this.trainTypeValue = ' - Departed ' + this.trainData.lastReportingCityState;
      }
    }
  }

  /**
   * this method is used to calculate the total
   * number of cars for a train.
   * total will be sum of empties and loads
   * @param {string} empties
   * @param {string} loads
   * @returns {string}
   * @memberOf LmsTrainDetailsComponent
   */
  getTotalCars(empties: string, loads: string): string {
    let car = 0;
    if (empties) {
      car = car + parseInt(empties, 10);
    }
    if (loads) {
      car = car + parseInt(loads, 10);
    }
    if (car > 0) {
      return car + '';
    } else {
      return '-';
    }
  }
  /**
     * Clean the state of lifecycle hook.
     * @memberOf LmsTrainDetailsComponent
     */
  ngOnDestroy() {
  }

}
